const GENERIC_EMAIL_NAMES = ["info", "admin", "support", "contact", "hello", "team", "office", "sales", "noreply", "no-reply"];

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

const firstNameFromEmail = (email) => {
  if (!email || !email.includes("@")) return "";
  const localPart = email.split("@")[0].split("+")[0].toLowerCase();
  if (!localPart || GENERIC_EMAIL_NAMES.includes(localPart)) return "";
  const firstPiece = localPart.split(/[._-]/)[0].replace(/\d+$/, "");
  return firstPiece.length > 1 ? capitalize(firstPiece) : "";
};

export const getFirstName = (user) => {
  const fromName = user?.name?.trim().split(/\s+/)[0];
  if (fromName) return fromName;
  return firstNameFromEmail(user?.email);
};

export const getTimeGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};
